
import { Component } from 'vue-property-decorator';
import TrafficSourceCreateForm from './create.vue';
import { pick } from 'lodash';

@Component
export default class Edit extends TrafficSourceCreateForm {

  child: boolean = true;

  get modalTitle(){
    return this.t('Duplicate traffic source')
  }

  async load() {
    this.traffic_source_id = this.$store.getters.selectedItem.id;

    await this.trafficSourceApi.get(this.traffic_source_id).then((data: any) => {
      this.form = pick(data, [
        'name',
        'status',
        'postbackUrl',
        'extClickIdParam',
        'extClickIdPlaceholder',
        'costParam',
        'costPlaceholder',
        'custom1Param',
        'custom1Placeholder',
        'custom1Name',
        'custom2Param',
        'custom2Placeholder',
        'custom2Name',
        'custom3Param',
        'custom3Placeholder',
        'custom3Name',
        'custom4Param',
        'custom4Placeholder',
        'custom4Name',
        'custom5Param',
        'custom5Placeholder',
        'custom5Name',
        'custom6Param',
        'custom6Placeholder',
        'custom6Name',
        'custom7Param',
        'custom7Placeholder',
        'custom7Name',
        'custom8Param',
        'custom8Placeholder',
        'custom8Name',
        'custom9Param',
        'custom9Placeholder',
        'custom9Name',
        'custom10Param',
        'custom10Placeholder',
        'custom10Name',
        'trafficLossPercent',
        'trackImpressions',
        'useTrafficLoss',
        'postbackSendConfirmStatus',
        'postbackSendNewStatus',
        'postbackSendChargebackStatus',
        'postbackSendDeclineStatus',
        'workspaceId',
        'postbackPercent',
        'tags',
        'integrationId',
      ]);

      return data;
    });
  }

  loadData() {
    this.$store.commit('loading', true);

    this.load()
      .then((data: any) => {
        this.form.name = this.form.name + ' (' + this.t('____x.copy') + ')';
        this.traffic_source_id = '';

        this.chips = this.getDefaultChips();
        this.changePostbackUrl();

        this.oldHash = this.getCurrentHash();
        this.show = true;
      })
      .finally(() => this.$store.commit('loading', false));
  }
}
